function padText(n, width, z) {
  try {
    if (n && width) {
      z = z || "0";
      n = n + "";
      return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    } else {
      return null
    }
  } catch {
    return null
  }
}

function removerTildes (texto) {
  return texto.normalize("NFD").replace(/[\u0300-\u036f]/g, "")
}

function getStrForLen (str, len, lower = false) {
  if (lower) {
    return str.substring(0,len).toLowerCase()
  } else {
    return str.substring(0,len).toUpperCase()
  }
}

// ENCODE UTF8
function encode_utf8(s)
{
	return encodeURI(encodeURIComponent(s));
}

// DECODE UTF8
function decode_utf8(s)
{
	return decodeURIComponent(decodeURI(s));
}
export { padText, removerTildes, getStrForLen, encode_utf8, decode_utf8 };
